import {configureStore} from '@reduxjs/toolkit';
import {userReducer} from '@local/redux/slice/user';
import {elasticsearchReducer} from '@local/redux/slice/elasticsearch';
import {propertyDetailReducer} from '@local/redux/slice/pages/propertyDetail';
import {adminSettingReducer} from '@local/redux/slice/pages/adminSetting';
import {snackbarReducer} from '@local/redux/slice/snackbar';
import {moveIoReducer} from '@local/redux/slice/pages/moveIo';
import {employeesReducer} from '@local/redux/slice/pages/employees';
import {moveIoUploadReducer} from '@local/redux/slice/pages/moveIoUpload';
import {employeesUploadReducer} from '@local/redux/slice/pages/employeesUpload';
import {loginReducer} from '@local/redux/slice/pages/login';
import {signupReducer} from '@local/redux/slice/pages/signupSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    elasticsearch: elasticsearchReducer,
    snackbar: snackbarReducer,
    login: loginReducer,
    signup: signupReducer,
    propertyDetail: propertyDetailReducer,
    adminSetting: adminSettingReducer,
    employees: employeesReducer,
    employeesUpload: employeesUploadReducer,
    moveIo: moveIoReducer,
    moveIoUpload: moveIoUploadReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
